import { cookie } from '@/utils/cookie'
import { getCurrentInstance } from '@vue/composition-api'
import { getChildRoutes } from '@/utils/getChildRoutes'
import { RouteConfigSingleView } from 'vue-router/types/router'
import { ComponentInstance } from '@vue/composition-api/dist/component'
import { serverLoginUrl } from '@/utils/identifyPages'

export class PageCookie {
  set (customRouteName: string, secure = true) {
    cookie.set(PageCookie.cookieKey, customRouteName, undefined, secure)
  }

  delete () {
    cookie.delete(PageCookie.cookieKey)
  }

  value (): string {
    return cookie.get(PageCookie.cookieKey)
  }

  static get cookieKey () {
    return 'loginPagePreference'
  }

  isEnabled (): boolean {
    const testValue = 'test'
    cookie.set(PageCookie.cookieEnabledCheckerKey, testValue, undefined, true)
    const storedCookieValue = cookie.get(PageCookie.cookieEnabledCheckerKey)
    const isEnabled = storedCookieValue === testValue
    cookie.delete(PageCookie.cookieEnabledCheckerKey)
    return isEnabled
  }

  static get cookieEnabledCheckerKey () {
    return 'cookieEnabledChecker'
  }
}

export class PageCookieComposable extends PageCookie {
  vm: ComponentInstance
  constructor () {
    super()
    this.vm = getCurrentInstance() as ComponentInstance
    this.set = this.set.bind(this)
  }

  set () {
    cookie.set(PageCookie.cookieKey, (this.vm as any).$route.name, undefined, true)
  }

  getCorrespondingPageRoute (): RouteConfigSingleView | undefined {
    if (!this.value()) {
      return
    }
    const loginRoutes = getChildRoutes((this.vm as any).$router, { path: serverLoginUrl })
    const correspondingRoute = loginRoutes.find(route => route.name === this.value())
    if (correspondingRoute) {
      return correspondingRoute
    } else {
      this.delete()
    }
  }
}

export default function () {
  return new PageCookieComposable()
}
